module.exports = __webpack_public_path__ + "static/media/ost_1.8bbeb733.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_1.png
// module id = 1037
// module chunks = 0